import { createFileRoute, Link } from "@tanstack/react-router";
import { StaticPage, staticHead } from "@/components/StaticPage";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
  head: () =>
    staticHead({
      title: "Terms of Use | AutoSpecData",
      description:
        "The terms that apply when you use AutoSpecData: acceptable use, accuracy and disclaimer, intellectual property, third-party links, and limitation of liability.",
      path: "/terms",
    }),
});

function TermsPage() {
  return (
    <StaticPage
      title="Terms of Use"
      intro="By using AutoSpecData you agree to the terms below. If you do not agree with them, please do not use the site."
    >
      <section>
        <h2>Reference information only</h2>
        <p>
          AutoSpecData publishes vehicle specifications and computed service intervals for
          reference. It is not a substitute for your vehicle's owner's manual, a
          manufacturer service bulletin, or advice from a qualified technician. Always
          confirm safety-critical figures — towing limits, tire sizes and pressures, torque
          values, and fluid specifications — against your vehicle's documentation before
          acting on them.
        </p>
      </section>
      <section>
        <h2>Accuracy and disclaimer</h2>
        <p>
          We work from official public sources and show where each figure came from, but we
          do not warrant that every value is complete, current, or free of error. The site
          is provided "as is", without warranties of any kind. To the fullest extent
          permitted by law, we are not liable for any loss, damage, or expense arising from
          reliance on information published here.
        </p>
      </section>
      <section>
        <h2>Acceptable use</h2>
        <ul>
          <li>Do not scrape the site at a rate that degrades it for other visitors.</li>
          <li>Do not republish substantial portions of the database as your own dataset.</li>
          <li>Do not attempt to breach, probe, or disrupt the service.</li>
          <li>Do not submit unlawful, abusive, or misleading content through our forms.</li>
        </ul>
        <p>
          Quoting a figure with attribution and a link back to the page it came from is
          welcome.
        </p>
      </section>
      <section>
        <h2>Intellectual property</h2>
        <p>
          Underlying specification data originates from public government sources and
          manufacturer documentation and remains subject to its own terms. The site's
          layout, written explanations, computed schedules, comparisons, and rankings are
          our work. Vehicle makes and model names are trademarks of their respective owners
          and are used here for identification only. AutoSpecData is not affiliated with, or
          endorsed by, any vehicle manufacturer.
        </p>
      </section>
      <section>
        <h2>Third-party links and advertising</h2>
        <p>
          Pages may link to third-party sites or display advertising. We do not control
          those destinations and are not responsible for their content, products, or
          policies.
        </p>
      </section>
      <section>
        <h2>Changes</h2>
        <p>
          These terms may be updated; continued use after an update means you accept the
          revised terms. Questions go through the <Link to="/contact">contact page</Link>.
        </p>
      </section>
    </StaticPage>
  );
}
